import React, { CSSProperties } from "react";
import Clock from "../../Tools/Clock";
import { useDisplays } from "../../../services/displayservices/DisplayProvider";

const DisplayClock = () => {
    const {display,getDisplayProperty,getDisplays} = useDisplays();

    const getClockStyle = ():CSSProperties => {
        let dispWid = getDisplayProperty("Width");
        let dispHei = getDisplayProperty("Height");

        let cs:CSSProperties = {
            height: dispHei + "px",
            width: dispWid + "px",
            position: "relative",
            background: getDisplayProperty("Backgroundcolor"),
        }
        return cs;
    }   
    const getText = ():string => {
        return getDisplayProperty("AdverText");
    };

  return (
    <div style={getClockStyle()}>
      <div dangerouslySetInnerHTML={{ __html: getText() }}></div>
      <div  style={{ bottom: "0px",position: "absolute" }}>
        <Clock />
      </div>
    </div>
  );
};

export default DisplayClock;
